module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2umF6P/tc-custom/9781488010873.jpg?1720639549433",
      "alt": "This image is the cover for the book Hot Pursuit, Hotshot Heroes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hot Pursuit, Hotshot Heroes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Sparks fly between an arson investigator and a sexy firefighter as they work together to stop a madman in this scorching hot romantic suspense.")]), _c('br'), _c('br'), _vm._v("For Braden Zimmer, leading his team of Hotshot firefighters isn’t just about being the best—it’s about sensing when a fire is coming. And a scorcher is "), _c('i', [_vm._v("definitely")]), _vm._v(" on its way. Maybe it’s from the dangerous arsonist who’s targeted him. Or maybe it has something to do with the sexy little investigator who’s been sent to protect Braden . . . "), _c('br'), _c('br'), _vm._v("Sam McRooney may be tiny and blonde but she doesn’t mess around. Braden is in serious danger, and she’s not about to jeopardize his life—even if he "), _c('i', [_vm._v("is")]), _vm._v(" hot enough to leave scorch marks on her libido. But with the arsonist growing bolder by the day, getting too close to this hunky Hotshot won’t just get her burned . . . it could get her killed.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Childs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times & USA Today bestselling, award-winning author Lisa Childs has written more than 85 novels. Published in 20 countries, she's also appeared on the Publisher's Weekly, Barnes & Nobles and Nielsen Top 100 bestseller lists. Lisa writes contemporary romance, romantic suspense, paranormal and women's fiction. She's a wife, mom, bonus mom, an avid reader and a less avid runner. Readers can reach her through Facebook or her website www.lisachilds.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0